export default "__VITE_ASSET__Bovo9ICC__"